import { useTranslation } from 'react-i18next';

import { Map } from '../components/Map/index.jsx';
import { Header } from '../components/index.jsx';
import { BreakpointMobile } from '../constants/ui';
import { useViewport } from '../hooks';
import { getSidebarLinksMap } from '../utils/ui';

const MapPage = () => {
  const { widthViewport } = useViewport();
  const { t } = useTranslation();
  const SidebarLinksMap = getSidebarLinksMap(t);

  return (
    <>
      {widthViewport > BreakpointMobile && <Header title={SidebarLinksMap.map.title} t={t} />}
      <main className="main">
        <Map t={t}/>
      </main>
    </>
  );
};

export default MapPage;
